module.exports = __webpack_public_path__ + "img/it.28c9efa4.jpeg";